import {
  useWindowSize 
} from "@/common/hooks/useWindowSize"
import React from "react";
import {
  ArrowLeft, ArrowRight 
} from "react-feather";
import Slider from "react-slick";
import Icon from "../Icon";

import classes from "./bannerSlider.module.css";

const BannerSlider = (props) => {
  const {
    cartBanners, isMiniCart 
  } = props;
  const windowSize = useWindowSize();

  const isMobile = windowSize.innerWidth <= 640;

  const identifiers = isMobile ? "home-banner-m" : "home-banner-pc";

  // clone一个新数组
  const cmsBannersClone = [...cartBanners];

  // 根据position排序
  // 写一个冒泡排序
  for (let i = 0; i < cmsBannersClone.length; i++) {
    for (let j = 0; j < cmsBannersClone.length - i - 1; j++) {
      if (cmsBannersClone[j].position > cmsBannersClone[j + 1].position) {
        const temp = cmsBannersClone[j];

        cmsBannersClone[j] = cmsBannersClone[j + 1];
        cmsBannersClone[j + 1] = temp;
      }
    }
  }

  function SampleNextArrow(props) {
    const {
      className, style, onClick 
    } = props;

    return (
      <div className={classes.rightNav} onClick={onClick}>
        <Icon src={ArrowRight} className={classes.navIcon} size={24} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const {
      className, style, onClick 
    } = props;

    return (
      <div className={classes.leftNav} onClick={onClick}>
        <Icon src={ArrowLeft} className={classes.navIcon} size={24} />
      </div>
    );
  }

  const sliderProps = {
    dots: true,
    infinite: true,
    showArrows: false,
    slidesToShow: 1,
    arrows: !isMobile,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 6000,
    nextArrow: isMobile ? false : <SampleNextArrow />,
    prevArrow: isMobile ? false : <SamplePrevArrow />
  };

  return (
    <Slider {...sliderProps} className={classes.homebanner}>
      {cmsBannersClone.map((item) => (
        <div className={classes.carouselItem} key={item.id}>
          <a className={classes.carouselLink} href={item.link}>
            <img
              className={classes.image}
              src={
                isMobile || isMiniCart ? item.m_pic : item.p_pic
              }
              alt=''
            />
          </a>
        </div>
      ))}
    </Slider>
  );
};

export default BannerSlider;
